<template>
  <div class="material">
    <div class="label">
      <div class="title">常见材料与附件</div>
      <van-button type="info" size="small" class="btn" @click="toUpload">上传材料</van-button>
    </div>
    <div class="list">
      <van-list
          class="job-list"
          v-model="refreshConfig.loading"
          :finished="refreshConfig.finished"
          :finished-text="refreshConfig.finishedText"
          :error.sync="refreshConfig.error"
          :error-text="refreshConfig.errorText"
          @load="onLoad"
        >
        <div class="list-item" v-for="(item, index) in list" :key="index">
          <van-swipe-cell :before-close="beforeClose">
            <div class="box">
              <img src="@/assets/info/file_icon.png" class="icon" />
              <div class="info">
                <div class="title">{{ item.CLMC }}</div>
                <div class="desc">上传日期：{{ item.SCRQ }}</div>
              </div>
            </div>
            <template #right>
              <div class="btn download" @click="downLoadFile(item,index)">
                <img src="@/assets/info/download_icon.png" class="icon" />
                <span>下载</span>
              </div>
              <div class="btn delete" @click="deleteFile(item,index)">
                <img src="@/assets/info/delete_icon.png" class="icon" />
                <span>删除</span>
              </div>
            </template>
          </van-swipe-cell>
        </div>
        <no-data v-if="list.length==0"></no-data>
      </van-list>
    </div>
  </div>
</template>

<script>
import NoData from '@/components/NoData.vue'
import api from '@/utils/api/personCenter'
import listMixins from '@/mixins/comListMixins'
import moduleMixins from '@/mixins/moduleMixins'
export default {
  components: {
    NoData
  },
  props: {},
  mixins: [listMixins, moduleMixins],
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      searchValue:'',
      list:[],
      loading: false,
      finished: false,
      // list: [{
      //   title: '多测合一系统接入规范.docx',
      //   time: '2022-06-08 14:24:22'
      // }, {
      //   title: '土地使用证、不动产权证.jpg',
      //   time: '2022-06-08 14:24:22'
      // }, {
      //   title: '身份证.jpg',
      //   time: '2022-06-08 14:24:22'
      // }, {
      //   title: '建设工程规划许可证.jpg',
      //   time: '2022-06-08 14:24:22'
      // }]
    };
  },
  watch: {},
  computed: {
    navTitle() {
      return '材料中心'
    }
  },
  methods: {
    toUpload() {
      this.$router.push({ name: 'MaterialUpload' })
    },
    beforeClose({ position, instance }) {
      console.log(position, instance)
      switch (position) {
        case 'left':
        case 'cell':
        case 'outside':
          instance.close();
          break;
        case 'right':
          // this.$dialog.confirm({
          //   message: '确定删除吗？',
          // }).then(() => {
          //   instance.close();
          // });
          break;
      }
    },
    loadData(data) {
      let params = {}
      params.page = data.page;
      params.pageSize = data.rows;
      // params.key = this.searchValue;
      return api.getMaterialLibrary(params).then(res => {
        console.log("getMaterialLibrary res:",res);
        // debugger
        if (data.page == 1) {
          this.list = res.data.rowsList
        } else {
          this.list.push(...res.data.rowsList)
        }
        this.finished = this.list.length >= res.data.total
        return Promise.resolve(res)
      })
      .catch(err => {
        console.log("err:",err.response);
      })
    },
    downLoadFile(item,index){
      //文件
      const params = this.UrlParamHash(item.FILEURL)
      console.log('params', params)
      let url =
        'macroPath=' +
        params['macroPath'] +
        '&fileName=' +
        decodeURI(params['fileName'])

      // window.location.href = url
      console.log("downLoadFile url:",url);
      if (window.__wxjs_environment === 'miniprogram') {
        wx.miniProgram.navigateTo({
          url: '/pages/downloadFile/downloadFile?' + url
        })
      } else {
        this.$toast.fail('请使用小程序下载')
      }
    },
    deleteFile(item,index) {
      let params = {}
      params.RID =  item.RID;
      this.$dialog.confirm({
        message: '确定要删除本条记录吗？',
      }).then(() => {
        return api.delMaterialLibrary(params).then(res => {
          console.log("delMaterialLibrary res:",res);
          this.$toast.success('删除成功')
          let page = {
            page: 1,
            rows: 20
          }
          this.loadData(page)
          return Promise.resolve(res)
        })
        .catch(err => {
          console.log("err:",err.response);
        })
      });
    },
    UrlParamHash(url) {
      var params = [],
        h
      var hash = url.slice(url.indexOf('?') + 1).split('&')
      //  console.log(hash)
      for (var i = 0; i < hash.length; i++) {
        h = hash[i].split('=') //
        params[h[0]] = h[1]
        //   console.log(h)
      }
      return params
    },
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.material {
  background-color: #fff;
  .label {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .btn {
      padding: 0 12px;
      border-radius: 5px;
    }
  }
  .list {
    &-item {
      .box {
        display: flex;
        padding: 0 10px;
        .icon {
          width: 40px;
          margin: 12px;
        }
        .info {
          .title {
            padding-top: 12px;
            font-weight: bold;
          }
          .desc {
            padding-top: 5px;
            color: #666;
          }
        }
      }
      .btn {
        width: 60px;
        height: 100%;
        text-align: center;
        color: #eee;
        display: inline-block;
        .icon {
          width: 20px;
          margin-top: 10px;
        }
        span {
          display: block;
        }
        &.download {
          background-color: #1D84FF;
        }
        &.delete {
          background-color: #F94347;
        }
      }
    }
  }
}
</style>